import { JobSearchQueryParams } from '@type/filters';

export function countAppliedFilters(queryParams?: unknown): number {
  const q = (queryParams || {}) as Partial<JobSearchQueryParams>;
  let total = 0;

  // Count multi-select arrays: each selected option counts as 1
  const arrayKeys: (keyof JobSearchQueryParams)[] = [
    'domain',
    'careerLevels',
    'employmentTypes',
    'spokenLanguages',
    'benefits',
    'location',
  ];

  arrayKeys.forEach((key) => {
    const value = q[key] as unknown as unknown[] | undefined;
    if (Array.isArray(value)) {
      total += value.filter(Boolean).length;
    }
  });

  // Single toggles/range-like fields
  if (q.remote === 1) total += 1;

  // Sort counts as 1 if not default (empty string = relevance)
  if (q.sort && q.sort.trim()) total += 1;

  // Ignore: cursor, limit, offset, _lat, _lon, includeSeoData, jobSearchId
  return total;
}
